import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Radio, Input, Button, Icon } from "antd";
import styles from "./ObservadorTaula.module.css";
import {
  paginacioPerDefecte,
  ordenarAttribut,
  obtenirEstatPerDefecte,
  seleccionarPaginacio,
  modificarColumnesBooleanesPerTextSiNo
} from "../commons/TaulaOrdenacioCerca";
import {
  esborrarObservadorSeleccionat,
  canviTextCercaVista
} from "../../actions";
import { rutaDetallObservador } from "../../routes";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { TEXT_QUAN_NO_HI_HA_DADA } from "../../constantsFormularis";
import { getCercaVistes } from "../../reducers";

const columnaNom = "nom";
const columnaCognom1 = "cognom1";
const columnaCognom2 = "cognom2";
const columnaUsuariNom = "usuariNom";
const columnaNomComarca = "comarca";
const columnaNomMunicipi = "municipi";
const columnaTelefon = "telefon";
const columnaDataAlta = "dataAlta";
const columnaDataBaixa = "dataBaixa";
const columnaUsuariActiu = "usuariActiu";
const columnaEstat = "estat";

// Aquesta parametrització de columnes està relacionada amb el mètode obtenirConfiguracioColumnes()
const columnesAmbFiltres = [
  columnaNom,
  columnaCognom1,
  columnaCognom2,
  columnaUsuariNom,
  columnaNomComarca,
  columnaNomMunicipi,
  columnaTelefon,
  columnaDataAlta,
  columnaDataBaixa,
  columnaUsuariActiu,
  columnaEstat
];

class ObservadorTaula extends Component {
  constructor(props) {
    super(props);
    const { observadors } = props;
    const observadorsSenseBooleans = modificarColumnesBooleanesPerTextSiNo(
      observadors
    );
    this.state = obtenirEstatPerDefecte(
      observadorsSenseBooleans,
      columnesAmbFiltres
    );
  }

  componentDidMount() {
    this.props.esborrarObservadorSeleccionat();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.observadors !== nextProps.observadors) {
      const { observadors } = nextProps;
      const observadorsSenseBooleans = modificarColumnesBooleanesPerTextSiNo(
        observadors
      );
      this.setState(() =>
        obtenirEstatPerDefecte(observadorsSenseBooleans, columnesAmbFiltres)
      );
    }
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Cerca...`}
          value={selectedKeys && selectedKeys[0] ? selectedKeys[0] : null}
          onChange={e => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            this.handleReset(clearFilters);
            this.props.canviTextCercaVista("", "");
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  obtenirConfiguracioColumnaOrdenadaIFiltrada(
    nom,
    item,
    tipus,
    amplada,
    valorFilter
  ) {
    return {
      title: nom,
      width: amplada ? amplada : 150,
      dataIndex: item,
      key: item,
      filteredValue: valorFilter ? [valorFilter] : null,
      sorter: (itemA, itemB) => ordenarAttribut(itemA, itemB, item, tipus),
      render: text => text || TEXT_QUAN_NO_HI_HA_DADA,
      ...this.getColumnSearchProps(item)
    };
  }

  obtenirConfiguracioColumnes(cercaVistes) {
    return [
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Nom",
        columnaNom,
        null,
        150,
        cercaVistes.columnaCerca === columnaNom ? cercaVistes.textCerca : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Cognom 1",
        columnaCognom1,
        null,
        150,
        cercaVistes.columnaCerca === columnaCognom1
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Cognom 2",
        columnaCognom2,
        null,
        150,
        cercaVistes.columnaCerca === columnaCognom2
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Usuari",
        columnaUsuariNom,
        null,
        105,
        cercaVistes.columnaCerca === columnaUsuariNom
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Telèfon",
        columnaTelefon,
        null,
        110,
        cercaVistes.columnaCerca === columnaTelefon
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Estat",
        columnaEstat,
        null,
        100,
        cercaVistes.columnaCerca === columnaEstat ? cercaVistes.textCerca : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Alta",
        columnaDataAlta,
        null,
        100,
        cercaVistes.columnaCerca === columnaDataAlta
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Baixa",
        columnaDataBaixa,
        null,
        100,
        cercaVistes.columnaCerca === columnaDataBaixa
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Municipi",
        columnaNomMunicipi,
        null,
        250,
        cercaVistes.columnaCerca === columnaNomMunicipi
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Comarca",
        columnaNomComarca,
        null,
        150,
        cercaVistes.columnaCerca === columnaNomComarca
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Actiu",
        columnaUsuariActiu,
        null,
        100,
        cercaVistes.columnaCerca === columnaUsuariActiu
          ? cercaVistes.textCerca
          : null
      )
    ];
  }

  onClickObservador(idObservador) {
    const { history, getDadesObservadorSeleccionat } = this.props;
    getDadesObservadorSeleccionat(idObservador);
    history.push({
      pathname: rutaDetallObservador
    });
  }

  render() {
    const { paginacio } = this.state;
    const { cercaVistes } = this.props;
    const mostrarSelectorPaginacio =
      this.state.data.length > 0 ? "block" : "none";

    return (
      <div className={styles.observadorTaula}>
        <Table
          dataSource={this.state.data}
          columns={this.obtenirConfiguracioColumnes(cercaVistes)}
          pagination={{ pageSize: paginacio, position: "bottom" }}
          bordered
          scroll={{ x: "max-content", y: 600 }}
          size="middle"
          onRow={record => ({
            onClick: () => {
              this.onClickObservador(parseInt(record.id, 0));
            }
          })}
          rowKey={record => record.id}
        />
        <Radio.Group
          className={styles.observadorTaulaSelectorPaginacio}
          size="small"
          onChange={event =>
            seleccionarPaginacio(event.target.value, this.setState.bind(this))}
          style={{ display: mostrarSelectorPaginacio }}
          value={paginacio}
        >
          <Radio.Button value={paginacioPerDefecte}>
            {paginacioPerDefecte}
          </Radio.Button>
          <Radio.Button value={40}>40</Radio.Button>
          <Radio.Button value={60}>60</Radio.Button>
          <Radio.Button value={100}>100</Radio.Button>
        </Radio.Group>
      </div>
    );
  }
}

ObservadorTaula.propTypes = {
  onClickObservador: PropTypes.func,
  observadors: PropTypes.arrayOf(
    PropTypes.shape({
      nom: PropTypes.string,
      cognom1: PropTypes.string,
      cognom2: PropTypes.string
    })
  ),
  history: PropTypes.object,
  getDadesObservadorSeleccionat: PropTypes.func,
  esborrarObservadorSeleccionat: PropTypes.func,
  canviTextCercaVista: PropTypes.func,
  cercaVistes: PropTypes.object
};

const mapStateToProps = state => {
  return {
    cercaVistes: getCercaVistes(state)
  };
};

const mapDispatchToProps = {
  esborrarObservadorSeleccionat,
  canviTextCercaVista
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(ObservadorTaula)
);
